import React from 'react';
import { Typography } from '@material-ui/core';

function AdminPackages() {
  return (
    <div>
      <Typography variant="h5">
        Admin Packages page is coming soon.
      </Typography>
    </div>
  );
}

export default AdminPackages;
